import { useTranslation } from 'react-i18next';

type DateStyle = 'short' | 'long' | 'datetime';

const DATE_OPTIONS: Record<DateStyle, Intl.DateTimeFormatOptions> = {
  short: { month: 'short', day: 'numeric', year: 'numeric' },
  long: { month: 'long', day: 'numeric', year: 'numeric' },
  datetime: { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' },
};

export function useFormatDate() {
  const { i18n } = useTranslation();

  return (date: number | string | Date, style: DateStyle = 'short') => {
    const d = date instanceof Date ? date : new Date(date);
    return d.toLocaleDateString(i18n.language, DATE_OPTIONS[style]);
  };
}
